import { render, staticRenderFns } from "./CommonShare.vue?vue&type=template&id=5c7f1abc&scoped=true"
import script from "./CommonShare.vue?vue&type=script&lang=js"
export * from "./CommonShare.vue?vue&type=script&lang=js"
import style0 from "./CommonShare.vue?vue&type=style&index=0&id=5c7f1abc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f1abc",
  null
  
)

export default component.exports